import moment from 'moment';
import * as yup from 'yup';

const isTextEditorValid = (content: string) => {
  const strippedContent = content.replace(/<(?!img\b)[^>]*>/g, '').trim();
  return strippedContent.length > 0;
};

export const formSchemaFn = (
  isActionEdit: boolean,
  isNotPermissionEdit: boolean,
) =>
  yup.object().shape({
    title: yup
      .string()
      .required('タイトルは未入力です。')
      .max(100, 'タイトルは100文字以内で入力してください。'),
    message: yup
      .string()
      .test('is-valid-message', '本文は未入力です。', (value) =>
        isTextEditorValid(value || ''),
      )
      .required('本文は未入力です。')
      .max(10000, '本文は10000文字以内で入力してください。'),
    status: yup
      .boolean()
      .required('ステータスは未入力です。')
      .oneOf([true, false], 'ステータスは未入力です。'),
    sentFromAt: yup
      .date()
      .required('開始日時を選択してください。')
      .when('status', ([status], schema) => {
        if ((isActionEdit && isNotPermissionEdit) || !status) {
          return schema;
        }

        return schema.min(
          moment().add(1, 'minute').startOf('minute').toDate(),
          '配信日時が過去の日時になっています。',
        );
      }),
  } as any);
